<template>
  <div class="page-content animate__animated animate__fadeIn">
    <div class="border-bottom" style="margin-top:0;">
      <!-- 顶部搜索框 -->
      <div>
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="缺陷类型名称">
            <el-input v-model="queryParams.typeName" placeholder="请输入缺陷类型名称进行查询" class="form-item-width"
              clearable></el-input>
          </el-form-item>

          <div class="btn-boxs">
            <div>
              <el-button icon="el-icon-plus" type="primary" @click="handledefectTypeAdd">新 增</el-button>
              <el-button :disabled="!multipleSelection.length" icon="el-icon-delete" type="danger"
                @click="batchDelete">批量删除</el-button>
            </div>
            <div>
              <el-button icon="el-icon-search" type="primary" @click="onSearch">查 询</el-button>
              <el-button icon="el-icon-refresh" @click="onReset">重 置</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="margin-top" style="margin-bottom:0;margin-top:15px">
      <!-- 表格组件 -->
      <el-table :data="tableData" v-loading="tableLoading" border row-key="deptId" default-expand-all
        :tree-props="{ children: 'children' }" highlight-current-row max-height="447"
        :header-cell-style="{ background: '#fafafa', color: '#606266', fontSize: '14px' }"
        @selection-change="handleSelectionChange">
        <!-- 多选 -->
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- 序号列 -->
        <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>
        <!-- 动态生成其他列 -->
        <el-table-column align="center" v-for="tab in tableTitle" :key="tab.code" :label="tab.name"
          show-overflow-tooltip :width="tab.width">
          <template slot-scope="scope">
            <!-- 针对 status 列的特殊处理 -->
            <span v-if="tab.code === 'status'"
              :style="scope.row.status === '0' ? { color: 'green' } : { color: 'red' }">{{ scope.row.status === '0' ?
                '正常' : '停用' }}</span>
            <span v-else-if="tab.code === 'sysModule'">{{ sysModuleMaping[scope.row.sysModule] }}</span>
            <span v-else>{{ scope.row[tab.code] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="updateData(scope.row)" class="update-btn">修改</el-button>
            <el-button style="color:red" type="text" @click="deleteData(scope.row)" class="update-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <div>
        <Pagination background :total="pageParams.total" :page="pageParams.pageNum" :limit="pageParams.pageSize"
          @pagination="onChangePages" />
      </div>
    </div>
    <!-- 添加 修改角色 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisble" width="30%" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="缺陷类型名称" prop="typeName">
          <el-input maxlength="20" show-word-limit v-model="form.typeName" autocomplete="off"
            placeholder="请输入缺陷类型名称"></el-input>
        </el-form-item>
        <el-form-item label="所属系统" prop="sysModule">
          <el-select v-model="form.sysModule" placeholder="请选择所属系统" @change="sysModuleChange">
            <el-option v-for="item in modelTypeList" :key="item.dictCode" :label="item.dictLabel"
              :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="缺陷等级" prop="defectGradeId" v-if="form.sysModule">
          <el-select v-model="form.defectGradeId" placeholder="请选择缺陷等级">
            <el-option v-for="item in defectGradeList" :key="item.defectGradeId" :label="item.gradeName"
              :value="item.defectGradeId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="缺陷描述" prop="describe">
          <el-input maxlength="20" show-word-limit v-model="form.describe" autocomplete="off"
            placeholder="请输入缺陷描述"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :icon="dialogTitle === '新增' ? 'el-icon-plus' : 'el-icon-edit'" type="primary"
          @click="submitForm('form')">{{ dialogTitle === '新增' ? '立即添加' : '立即修改' }}</el-button>
        <el-button icon="el-icon-refresh" @click="resetForm('form')">重 置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import {getDefectTypeList,defectTypeAdd,defectTypeById, updeteDefectType, deleteDefectType} from "@/api/data-service/defectType.js";
import { getDefectGradeAll } from "@/api/data-service/defectGrade.js";
import { getSystemModel } from "@/api/admin-service/dictDataType.js";

export default {
  components: {
    Pagination
  },
  data() {
    return {
      tableLoading: false,
      form: {
        typeName: "",
        describe: "", //  缺陷类型
        defectGradeId: "", //
        sysModule: "" //新增
      },
      rules: {
        typeName: [
          { required: true, message: "请填写缺陷类型名称", trigger: "blur" }
        ],
        describe: [
          { required: true, message: "请填写缺陷描述", trigger: "blur" }
        ],
        defectGradeId: [
          { required: true, message: "请选择缺陷等级", trigger: "change" }
        ],
        sysModule: [
          { required: true, message: "请选择所属系统", trigger: "blur" }
        ]
      },
      dialogTitle: "",
      updateId: "", //修改数据需要的id
      dialogFormVisble: false,
      // 表格数据
      tableData: [],
      // 表格标题数组
      tableTitle: [
        { name: "缺陷类型名称", code: "typeName", width: "" },
        { name: "缺陷等级", code: "gradeName", width: "" },
        { name: "缺陷描述", code: "describe", width: "" },
        { name: "所属系统", code: "sysModule", width: "" }
      ],
      sysModuleMaping: {
        1: "1C",
        2: "2C",
        3: "3C",
        4: "4C",
        5: "5C",
        6: "浮冰监测",
        7: "隧道2C"
      },
      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      queryParams: {
        typeName: ""
      },
      defectGradeList: [],
      multipleSelection: [],
      modelTypeList: []
    };
  },
  mounted() {
    this.onGetDataList();
    // this.queryDefectGradeList();
    this.getSystemModel();
  },

  methods: {
    sysModuleChange(val) {
      this.form.defectGradeId = ''
      this.queryDefectGradeList({ sysModule: val })
    },
    queryDefectGradeList(params) {
      getDefectGradeAll({
        gradeName: "",
        sysModule: params.sysModule,
        ...this.pageParams
      }).then(res => {
        this.defectGradeList = res?.data || [];
      });
    },
    getSystemModel() {
      getSystemModel({ type: "sys_model_type" }).then(res => {
        this.modelTypeList = res?.data || [];
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchDelete() {
      this.$confirm(`提示，确定要删除选中的这些数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        // 为按钮添加图标并设置为 mini 尺寸
        confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
        cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
      })
        .then(() => {
          // 使用 map() 来获取 defectTypeId 组成的数组
          const ids = (this.multipleSelection || []).map(
            item => item.defectTypeId
          );
          deleteDefectType({ ids }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    addData() {
      this.dialogTitle = "新增";
      this.dialogFormVisble = true;
    },
    // 增 / 改
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const formData = { ...this.form };
          delete formData.defectTypeId; // 清除 defectTypeId
          if (this.dialogTitle === "新增") {
            defectTypeAdd(formData).then(res => {
              if (res.data) {
                this.$message.success(res.msg || "新增成功！");
                this.dialogFormVisble = false;
                this.onGetDataList();
              }
            });
          } else {
            updeteDefectType({
              ...this.form,
              defectTypeId: this.updateId
            }).then(r => {
              if (r.data) {
                this.$message.success(r.msg || "修改成功！");
                this.dialogFormVisble = false;
                this.onGetDataList();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删
    deleteData(row) {
      this.$confirm(`提示，确定要删除该条数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        // 为按钮添加图标并设置为 mini 尺寸
        confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
        cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
      })
        .then(() => {
          deleteDefectType({ ids: [row.defectTypeId] }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 改
    updateData(row) {
      this.dialogTitle = "修改";
      this.dialogFormVisble = true;
      this.updateId = row.defectTypeId;
      defectTypeById({ id: row.defectTypeId }).then(res => {
        const data = res?.data;
        // 强制转换
        Object.assign(this.form, data);
        this.form.sysModule = String(data.sysModule);
        this.queryDefectGradeList({ sysModule: data.sysModule })
      });
    },
    // 查
    onGetDataList() {
      this.tableLoading = true;
      getDefectTypeList({
        ...this.queryParams,
        ...this.pageParams
      })
        .then(res => {
          const { records, total } = res.data;
          this.tableData = records;
          this.pageParams.total = total;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    handledefectTypeAdd() {
      this.dialogTitle = "新增";
      this.dialogFormVisble = true;
    },
    handleDialogClose() {
      this.resetForm("form");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 查询
    onSearch() {
      this.onGetDataList();
    },
    // 重置
    onReset() {
      this.pageParams.pageNum = 1;
      this.pageParams.pageSize = 10;
      this.queryParams.typeName = "";
      this.onSearch();
    },
    // 分页方法
    onChangePages(pageInfo) {
      this.pageParams.pageNum = pageInfo.page;
      this.pageParams.pageSize = pageInfo.limit;
      this.onGetDataList();
    }
  }
};
</script>
<style lang="less" scoped>
.analyse-container {
  display: flex;
  height: 95vh;
}

.form-item-width {
  width: 250px;
}

.right-btns {
  position: absolute;
  right: 20px !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}

.margin-top {
  margin-top: -15px;
}

.custom-tree-node {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  .tree-node-label {
    font-size: 12px;
    font-weight: bold;
  }
}
</style>
